<div class="panel-heading">
    <p class="panel-title"><b>606 - CAT Comparison
        </b></p>
</div>
<div class="comparison-page">

    <div class="col-lg-12 nopadding">
        @if(isLoadingResults){
        <div class="example-loading-shade">
            <mat-spinner></mat-spinner>
        </div>
        }
        <section class="comparison-section">

            <div class="section-title">
                <h2>Order comparison</h2>
                <p>
                    606 reported <b style="color: #000; font-weight: 800 !important">HELD</b> order counts vs CAT reported <b style="color: #000; font-weight: 800 !important">HELD</b> order counts by categories
                </p>
            </div>

            <div class="comparison-table-wrapper">

                <p-table [value]="orderComparisonData" styleClass="cat-comparison-table">

                    <ng-template #header>

                        <tr>

                            <th rowspan="2">
                                Categories
                            </th>

                            <th colspan="3">
                                <div class="group-header">
                                    <span class="group-title">
                                        Equities Total Order Count <b>
                                            {{ orderEquitiesTotal | number }} </b>
                                    </span>
                                </div>
                            </th>

                            <th colspan="3">
                                <div class="group-header">
                                    <span class="group-title">
                                        Options Total Order Count <b>
                                            {{ orderOptionsTotal | number }} </b>
                                    </span>
                                </div>
                            </th>

                        </tr>

                        <tr>
                            <th style="text-align: center !important;">606</th>
                            <th>CAT</th>
                            <th>Variance</th>

                            <th style="text-align: center !important;">606</th>
                            <th>CAT</th>
                            <th>Variance</th>

                        </tr>
                    </ng-template>


                    <ng-template #body let-row>
                        <tr>

                            <td class="category">
                                {{ row.category }}
                            </td>

                            <td>
                                {{ row.equities.odr | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.equities.odr,
                                    orderEquitiesTotal
                                    ) }}%)
                                </span>
                            </td>

                            <td>
                                {{ row.equities.cat | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.equities.cat,
                                    CATorderEquitiesTotal
                                    ) }}%)
                                </span>
                            </td>


                            <td>
                                <span class="variance"
                                    [ngClass]="getVarianceClass(calculateVariance(row.equities.odr,row.equities.cat))">

                                    {{ calculateVariance(row.equities.odr, row.equities.cat) === null ? '0' :
                                    (getAbsoluteValue(calculateVariance(row.equities.odr,row.equities.cat))
                                    | number:'1.2-2') }}%

                                </span>
                            </td>

                            <td>
                                {{ row.options.odr | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.options.odr,
                                    orderOptionsTotal
                                    ) }}%)
                                </span>
                            </td>

                            <td>
                                {{ row.options.cat | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.options.cat,
                                    CATorderOptionsTotal
                                    ) }}%)
                                </span>
                            </td>



                            <td>
                                <span class="variance"
                                    [ngClass]="getVarianceClass(calculateVariance(row.options.odr,row.options.cat))">

                                    {{ calculateVariance(row.options.odr, row.options.cat) === null ? '0' :
                                        (getAbsoluteValue(calculateVariance(row.options.odr, row.options.cat))
                                    | number:'1.2-2') }}%

                                </span>
                            </td>

                        </tr>
                    </ng-template>

                </p-table>

            </div>

        </section>



        <div class="comparison-divider"></div>


        <section class="comparison-section">

            <div class="section-title">
                <h2>Route comparison</h2>
                <p>
                    606 reported <b style="color: #000; font-weight: 800 !important">HELD</b> route counts vs CAT reported <b style="color: #000; font-weight: 800 !important">HELD</b> Route counts by categories
                </p>
            </div>

            <div class="comparison-table-wrapper">

                <p-table [value]="routeComparisonData" styleClass="cat-comparison-table">


                    <ng-template #header>

                        <tr>


                            <th rowspan="2">
                                Categories
                            </th>


                            <th colspan="3">
                                <div class="group-header">
                                    <span class="group-title">
                                        Equities Total Route Count <b>
                                            {{ routeEquitiesTotal | number }}</b>
                                    </span>

                                </div>
                            </th>


                            <th colspan="3">
                                <div class="group-header">
                                    <span class="group-title">
                                        Options Total Route Count <b>
                                            {{ routeOptionsTotal | number }}</b>
                                    </span>
                                </div>
                            </th>

                        </tr>


                        <tr>

                            <th style="text-align: center !important;">606</th>
                            <th>CAT</th>
                            <th>Variance</th>

                            <th style="text-align: center !important;">606</th>    
                            <th>CAT</th>
                            <th>Variance</th>

                        </tr>
                    </ng-template>



                    <ng-template #body let-row>
                        <tr>


                            <td class="category">
                                {{ row.category }}
                            </td>

                            <td>
                                {{ row.equities.odr | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.equities.odr,
                                    routeEquitiesTotal
                                    ) }}%)
                                </span>
                            </td>

                            <td>
                                {{ row.equities.cat | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.equities.cat,
                                    CATrouteEquitiesTotal
                                    ) }}%)
                                </span>
                            </td>


                            <td>
                                <span class="variance"
                                    [ngClass]="getVarianceClass(calculateVariance(row.equities.odr, row.equities.cat))">

                                    {{ calculateVariance(row.equities.odr,row.equities.cat) === null ? '0' :            
                                        (getAbsoluteValue(calculateVariance(row.equities.odr,row.equities.cat))
                                    | number:'1.2-2') }}%

                                </span>
                            </td>


                            <td>
                                {{ row.options.odr | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.options.odr,
                                    routeOptionsTotal
                                    ) }}%)
                                </span>
                            </td>

                            <td>
                                {{ row.options.cat | number }}

                                <span class="percentage">
                                    ({{ getPercentage(
                                    row.options.cat,
                                    CATrouteOptionsTotal
                                    ) }}%)
                                </span>
                            </td>


                            <td>
                                <span class="variance"
                                    [ngClass]="getVarianceClass(calculateVariance(row.options.odr, row.options.cat))">

                                   {{ calculateVariance(row.options.odr, row.options.cat) === null ? '0' :            
                                        (getAbsoluteValue(calculateVariance(row.options.odr, row.options.cat))
                                    | number:'1.2-2') }}%


                                </span>
                            </td>

                        </tr>
                    </ng-template>

                </p-table>

            </div>

        </section>

    </div>